<template>
  <v-container>
    <v-row >
      <v-col cols="12" sm="6" offset-sm="3">
        <v-card>
          <v-card-title><h3>Enter your new password</h3></v-card-title>
          <v-card-text>
            <v-container>
              <form @submit.prevent="ChangePassword">
                <v-row >
                  <v-col cols="12">
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      hint="At least 8 characters, up to 255, no special requirements just don't please don't use common words/passwords."
                      min="8"
                      :counter="255"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12">
                    <v-text-field
                      name="confirmPassword"
                      label="Confirm Password"
                      id="confirmPassword"
                      v-model="confirmPassword"
                      type="password"
                      required
                      :rules="[comparePasswords]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="12">
                    <v-btn class="primary" type="submit" :disabled="loading" :loading="loading">
                      Submit New Password
                      <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ResetPasswordConfirm',
  data: () => ({

    password: '',
    confirmPassword: '',

  }),
  created: {
  },
  computed: {
    comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true;
    },
  },
  methods: {
    ChangePassword() {
      const verificationuid = this.$route.params.uid;
      const verificationkey = this.$route.params.key;
      return axios.post('/rest-auth/password/reset/confirm/', {
        new_password1: this.password,
        new_password2: this.confirmPassword,
        uid: verificationuid,
        token: verificationkey,
      })
        .then(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Password successfully changed! You can go ahead and sign in now',
            alert_model: true,
          });
          this.$router.push('/sign_in');
        })
        .catch((error) => {
          // this regex fix is stilllll pretty hacky, but it seems to work now.
          const regex = /\[(.*?)\]/;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline',
            alert_color: 'error',
            alert_message: `Sorry, something seems to have gone wrong. Please try again. Our system says: ${regex.exec(error.response.request.response)[1].replace(/['"]+/g, '')}`,
            alert_model: true,
          });
        });
    },
  },

};


</script>

<style scoped>

</style>
